<script>
  export let headerBackground
  import { onMount, onDestroy } from "svelte"
  export let column

  /**
   * @type {Number} Width of the individual color box
   */
  let width

  /**
   * @type {Boolean} whether to show the color palette or custom textarea
   */
  let showCustomInput = false

  /**
   * @type {String} custom linear gradient value
   */
  let customGradient

  /**
   * @type {HTMLElement} binded the overall textarea element
   */
  let textarea

  /**
   * @type {Array} list of gradient colors
   */
  let gradientColors = [
    "linear-gradient(62deg, #FBAB7E 0%, #F7CE68 100%)",
    "linear-gradient(160deg, #0093E9 0%, #80D0C7 100%)",
    "linear-gradient(90deg, #FF9A8B 0%, #FF6A88 55%, #FF99AC 100%)",
    "linear-gradient(132deg, #F4D03F 0%, #16A085 100%)",
    "linear-gradient(99deg, #731251 0%, #1C1C1C 100%)",
    "linear-gradient(63deg, #05176F 0%, #185FF0 100%)",
    "linear-gradient(120deg, #EA580C 0%, #F97316 100%)",
    "linear-gradient(30deg, #1D4ED8 0%, #1E40AF 100%)",
    "linear-gradient(83deg, #965DE9 0%, #6358EE 100%)",
    "linear-gradient(45deg, #FF5F6D 0%, #FFC371 100%)",
    "linear-gradient(120deg, #89F7FE 0%, #66A6FF 100%)",
    "linear-gradient(135deg, #FF9A9E 0%, #FAD0C4 100%)",
    "linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%)",
    "linear-gradient(60deg, #FEE140 0%, #FA709A 100%)",
    "linear-gradient(150deg, #37D5D6 0%, #36096D 100%)",
    "linear-gradient(140deg, #A18CD1 0%, #FBC2EB 100%)",
    "linear-gradient(160deg, #F36265 0%, #961276 100%)",
    "linear-gradient(75deg, #FFDEE9 0%, #B5FFFC 100%)",
    "linear-gradient(120deg, #FFB75E 0%, #ED8F03 100%)",
    "linear-gradient(90deg, #43C6AC 0%, #191654 100%)",
    "linear-gradient(135deg, #667EEA 0%, #764BA2 100%)",
    "linear-gradient(60deg, #3A1C71 0%, #FFAF7B 100%)",
    "linear-gradient(45deg, #FF4E50 0%, #F9D423 100%)",
    "linear-gradient(90deg, #16BFFD 0%, #CB3066 100%)",

    // "linear-gradient( 83.2deg,  rgba(150,93,233,1) 10.8%, rgba(99,88,238,1) 94.3% )",
    // "linear-gradient( 68.3deg,  rgba(245,177,97,1) 0.4%, rgba(236,54,110,1) 100.2% )",
    // "radial-gradient( circle farthest-corner at 10% 20%,  rgba(37,145,251,0.98) 0.1%, rgba(0,7,128,1) 99.8% )",
    // "linear-gradient( 99deg,  rgba(115,18,81,1) 10.6%, rgba(28,28,28,1) 118% )",
    // "linear-gradient( 63.1deg,  rgba(5,23,111,1) 16.4%, rgba(24,95,240,1) 64.5% )",
    // "radial-gradient(circle, rgba(2,0,36,1) 0%, rgba(11,9,121,1) 35%, rgba(0,212,255,1) 100%)",
    // "linear-gradient(0deg, rgba(34,193,195,1) 0%, rgba(253,187,45,1) 100%)",
    // "radial-gradient(circle, rgba(63,94,251,1) 0%, rgba(252,70,107,1) 100%)",
    // "radial-gradient(circle, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)",
  ]
  /**
   * @type {HTMLElement} binded the overall palette container
   */
  let container

  onMount(() => {
    // let fixedWidth
    // if (window.innerWidth > 1280) fixedWidth = 49.6
    // else if (window.innerWidth > 1024) fixedWidth = 45
    // else if (window.innerWidth > 768) fixedWidth = 40
    // else if (window.innerWidth > 640) fixedWidth = 35
    // else fixedWidth = 30
    // let sharedWidth = container.clientWidth / (fixedWidth * 7)
    // width = fixedWidth + sharedWidth
  })

  /**
   * @description Function for setting the textarea height with repect to the scroll height
   */
  const autoGrow = () => {
    if (textarea) textarea.style.height = textarea.scrollHeight + "px"
  }

  let timer = setInterval(autoGrow, 50)

  onDestroy(() => {
    clearTimeout(timer)
  })

  /**
   * @description Function for the validating and updating the new applied gradient
   */
  const applyGradient = () => {
    if (customGradient) {
      customGradient = customGradient.replace("background:", "")
      customGradient = customGradient.replace(";", "")
      showCustomInput = false
      gradientColors.shift()
      gradientColors = [...gradientColors, customGradient]
      // gradientColors = [...new Set(gradientColors)]
      headerBackground = customGradient
      customGradient = ""
    } else {
      textarea.focus()
    }
  }
</script>

<div bind:this={container}>
  <h1 class="py-3 text-base font-medium text-[#868484] dark:text-slate-200">Standard Gradients</h1>
  {#if showCustomInput}
    <div class="flex flex-col gap-3">
      <textarea on:input={autoGrow} bind:value={customGradient} bind:this={textarea} class="block min-h-[100px] w-full resize-none overflow-hidden rounded-md border border-[#a0a1a580] bg-white px-3 py-2 pb-9 pl-5 text-justify text-sm text-gray-800 outline-none placeholder:text-gray-200 focus:border focus:border-extraBlue-500 focus:ring-1 focus:ring-extraBlue-500" placeholder="Paste CSS gradient code here.." />

      <div class="flex w-full justify-end gap-3">
        <button
          on:click|stopPropagation={() => {
            showCustomInput = false
          }}
          type="button"
          class="flex h-[28.8px] w-1/4 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-2 text-sm font-medium text-gray-900 hover:bg-red-500 hover:text-white focus:outline-none active:bg-red-600 lg:px-4"
        >
          <span>
            <i class="fa-solid fa-trash" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Cancel&nbsp;</span>
        </button>
        <button on:click|stopPropagation={applyGradient} type="button" class="flex h-[28.8px] w-1/4 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-2 text-sm font-medium text-gray-900 hover:bg-green-500 hover:text-white focus:outline-none active:bg-[#a0a1a533] lg:px-4">
          <span>
            <i class="fa-solid fa-circle-check" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Apply&nbsp;</span>
        </button>
      </div>
    </div>
  {:else}
    <!-- <div class="grid gap-1" style="grid-template-columns: repeat(auto-fit, minmax({width}px,1fr));"> -->
    <div class="grid gap-2" style="grid-template-columns: repeat({column}, 1fr)">
      {#each gradientColors as color}
        <button
          on:click={() => {
            headerBackground = color
          }}
          type="button"
          class="h-[28.8px] rounded-[3px] {color == headerBackground ? 'ring-1 ring-extraBlue-500' : ''} hover:scale-110 hover:shadow-colorShadow"
          style="background:{color}"
        />
      {/each}
      <button
        disabled={true}
        on:click|stopPropagation={() => {
          showCustomInput = true
        }}
        type="button"
        class="flex h-[28.8px] w-[52.4px] items-center justify-center pr-0.5 disabled:cursor-not-allowed"
      >
        <div class="flex h-full w-full items-center justify-center rounded-[3px] border border-[#a0a1a580] bg-transparent disabled:cursor-not-allowed">
          <i class="fa-solid fa-plus text-gray-200" />
        </div>
      </button>
    </div>
  {/if}
</div>
